module.exports = __webpack_public_path__ + "img/img_ct01.2f91262e.jpg";